export default "__VITE_ASSET__BWUtzNHn__"